module.exports = __webpack_public_path__ + "static/dimm2-0dc3da051b690a01c190f596cb00d4cd.mp4";